import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  CreateRepository,
  CreateRepositoryExtensionSchema,
  ExistingRepository,
  ExistingRepositoryExtensionSchema,
  OIDCRole,
  OIDCRoleExtensionSchema,
  RepositoryName,
  RepositoryNameExtensionSchema,
  validateCreateRepository,
  validateOIDCRole,
  validateRepositoryName,
} from './CICD';

export const AWSWorkloadExistingRepositoryFieldExtension =
  scaffolderPlugin.provide(
    createScaffolderFieldExtension({
      name: 'AWSWorkload_ExistingRepositoryField',
      component: ExistingRepository,
      schema: ExistingRepositoryExtensionSchema,
    }),
  );

export const AWSWorkloadOIDCRoleFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AWSWorkload_OIDCRoleField',
    component: OIDCRole,
    validation: validateOIDCRole,
    schema: OIDCRoleExtensionSchema,
  }),
);

export const AWSWorkloadCreateRepositoryFieldExtension =
  scaffolderPlugin.provide(
    createScaffolderFieldExtension({
      name: 'AWSWorkload_CreateRepositoryField',
      component: CreateRepository,
      validation: validateCreateRepository,
      schema: CreateRepositoryExtensionSchema,
    }),
  );

export const AWSWorkloadRepositoryNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AWSWorkload_RepositoryNameField',
    component: RepositoryName,
    validation: validateRepositoryName,
    schema: RepositoryNameExtensionSchema,
  }),
);
